import {
  CHANGE_PASSPORT_DATA_CHILD,
  BLUR_PASSPORT_DATA_CHILD,
  CHANGE_DOCUMENT_TYPE_CHILD
} from '../constants';

export const changePassportDataChild = payload => ({
  type: CHANGE_PASSPORT_DATA_CHILD,
  payload
});
export const blurPassportDataChild = payload => ({
  type: BLUR_PASSPORT_DATA_CHILD,
  payload
});
export const changeDocumentTypeChild = payload => ({
  type: CHANGE_DOCUMENT_TYPE_CHILD,
  payload
});
